export class AuditPackageContext {
  readonly firstName: string;
  readonly lastName: string;
  readonly userID: number;
  readonly isEditable: boolean;
  readonly isLoggedIn: boolean;

  constructor(options: {
    firstName: string;
    lastName: string;
    userID: number;
    isEditable: boolean;
    isLoggedIn: boolean;
  }) {
    this.firstName = options.firstName;
    this.lastName = options.lastName;
    this.userID = options.userID;
    this.isEditable = options.isEditable;
    this.isLoggedIn = options.isLoggedIn;
  }
}
